(() => {
  const initSliders = () => {
    const slideshows = document.querySelectorAll(".slideshow__swiper");
    slideshows.forEach((slideshow) => {
      const autoplay =
        slideshow.getAttribute("data-autoplay") === "true" ? true : false;
      const fade = slideshow.getAttribute("data-transition") === "fade";
      const swiperOptions = {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        autoHeight: false,
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      };
      if (fade) {
        swiperOptions.effect = "fade";
        swiperOptions.fadeEffect = { crossFade: true };
      }
      if (autoplay) {
        const firstSlide = slideshow.querySelector(
          ".swiper-slide[data-swiper-autoplay]"
        );
        const autoplayDelay = firstSlide
          ? parseInt(firstSlide.getAttribute("data-swiper-autoplay"), 10)
          : 5000;
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }
      const slideshowSwiper = new Swiper(slideshow, swiperOptions);
      if (autoplay) {
        slideshow.addEventListener("mouseenter", () => {
          slideshowSwiper.autoplay.pause();
        });
        slideshow.addEventListener("mouseleave", () => {
          slideshowSwiper.autoplay.resume();
        });
      }
      if (slideshowSwiper.addSlide.length < 2) {
        slideshowSwiper.allowTouchMove = false;
      } else {
        slideshowSwiper.allowTouchMove = true;
      }
      if (slideshowSwiper.addSlide.length > 1)
        slideshow.classList.add("slideshow__swiper--multiple-slides");
    });
  };

  initSliders();

  document.addEventListener("shopify:section:load", function () {
    initSliders();
  });
})();
